<template>
    <div class="container-fluid" id="img-ly-scene-editor">
        <div class="card">
            <div class="card-body" style="position: relative">
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <div v-if="loading">
                    <loading></loading>
                    <div v-if="add_template || replace_template" class="mt-3 text-center">
                        {{ $root.text(
                            'Here you can fix any import issues then mark the {template} as ready for tagging etc. '
                                + 'Loading editor, please wait...',
                            {
                                template: $root.text(
                                    $root.contents.template_title,
                                    null,
                                    false,
                                    'template_title'
                                )
                            },
                            true
                        ) }}
                    </div>
                </div>

                <div :style="'display: ' + ((loading || (scene.data === null)) ? 'none' : 'block')">
                    <div class="row mb-3">
                        <div class="col-lg-3 col-md-4 col-sm-12">
                            <table>
                                <tbody>
                                    <tr>
                                        <td height="35" valign="middle">
                                            <h5 class="scene-title mb-0">
                                                {{ scene.title ? scene.title : $root.text('Title', null, true) }}
                                            </h5>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col" :key="getStatusKey()">
                            <span v-if="showReadyForTagging()">
                                <button
                                    v-if="creating_scene && (create_scene_action == 'ready-for-tagging')"
                                    :key="'ready-for-tagging-spinner-xxl'"
                                    class="btn btn-secondary mr-2"
                                    type="button"
                                >
                                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                                    <span style="opacity: 0.5">{{ $root.text('Ready for tagging', null, true) }}</span>
                                </button>
                                <button
                                    v-else
                                    :key="'ready-for-tagging-button-xxl'"
                                    class="btn btn-secondary mr-2"
                                    type="button"
                                    @click="createScene('ready-for-tagging')"
                                    :disabled="isReadyForTaggingDisabled()"
                                >
                                    <i class="far fa-tags mr-1"></i>
                                    {{ $root.text('Ready for tagging', null, true) }}
                                </button>
                            </span>

                            <span v-if="showFinish()">
                                <button
                                    v-if="creating_scene && (create_scene_action == 'finish')"
                                    :key="'finish-spinner-xxl'"
                                    class="btn btn-primary"
                                    type="button"
                                >
                                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                                    <span style="opacity: 0.5">{{ $root.text('Finish', null, true) }}</span>
                                </button>
                                <button
                                    v-else
                                    :key="'finish-button-xxl'"
                                    class="btn btn-primary"
                                    type="button"
                                    @click="createScene('finish')"
                                    :disabled="isFinishDisabled()"
                                >
                                    <i class="far fa-check mr-1"></i> {{ $root.text('Finish', null, true) }}
                                </button>
                            </span>

                            <button
                                v-if="creating_scene && (create_scene_action == 'save')"
                                :key="'save-spinner-xxl'"
                                class="btn btn-secondary float-right"
                                type="button"
                            >
                                <i class="fal fa-spinner-third fa-spin mr-1"></i>
                                <span style="opacity: 0.5">{{ $root.text('Save for later', null, true) }}</span>
                            </button>
                            <button
                                v-else
                                :key="'save-button-xxl'"
                                class="btn btn-secondary float-right"
                                type="button"
                                @click="createScene('save')"
                                :disabled="isSaveDisabled()"
                            >
                                <i class="far fa-save mr-1"></i>
                                {{ $root.text('Save for later', null, true) }}
                            </button>
                        </div>
                    </div>
                    <div :style="'display: ' + (!editor_loaded ? 'none' : 'block')">
                        <div id="cesdk-se-container" class="cesdk-container" style="height: calc(100vh - 220px); width: 100%"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CreativeEditorSDK from '@cesdk/cesdk-js';
    export default {
        components: { CreativeEditorSDK },
        data () {
            return {
                component_name: 'img-ly-scene-editor',
                errors: false,
                on_close_redirect_to: null,
                scene: {
                    title: '',
                    data: null,
                    ready_for_tagging: false,
                    finished: false
                },
                loading: true,
                cesdk: null,
                editor_loaded: false,
                scene_changed: true,
                editing_scene_title: false,
                new_scene_title: null,
                updating_scene_title: false,
                create_scene_action: null,
                creating_scene: false,
                add_template: false,
                replace_template: false,
                asset_details_component: null,
                template_fonts: []
            }
        },
        mounted () {
            $('body').removeClass('login-body');
            this.initEditor();
            var vm = this;
            $(window).bind('beforeunload', function(eventObject) {
                let returnValue = undefined;
                if (vm.$root.editing_img_ly_scene && vm.scene_changed) {
                    returnValue = vm.$root.text('Are you sure you want to discard your current changes?', null, true);
                }
                eventObject.returnValue = returnValue;

                return returnValue;
            });
        },
        beforeUnmount () {
            this.scene.data = null;
            if (this.cesdk) {
                this.cesdk.dispose();
                this.cesdk = null;
            }
        },
        watch: {
            //
        },
        methods: {
            async initEditor() {
                const cesdkConfig = {
                    license: this.$root.app.img_ly_license_key,
                    //baseURL: 'https://cdn.img.ly/packages/imgly/cesdk-js/1.66.1/assets',
                    baseURL: '/img-ly-assets',
                    ui: {
                        /*panels: {
                            inspector: {
                                show: true
                            }
                        },*/
                        elements: {
                            //view: 'advanced',
                            blocks: {
                                canvas: false,
                                layer: false,
                                opacity: false,
                                transform: false,
                                fill: false,
                                stroke: false,
                                shape: false,
                                appearance: false,
                                '//ly.img.ubq/graphic': {
                                    adjustments: false,
                                    filters: false,
                                    effects: false,
                                    blur: false,
                                    crop: false,
                                    fill: false
                                }
                            }
                        }
                    },
                    callbacks: {
                        onUpload: 'local'
                    }
                };

                var vm = this;

                this.cesdk = await CreativeEditorSDK.create('#cesdk-se-container', cesdkConfig);
                //await this.cesdk.i18n.setLocale('en');
                await this.cesdk.addDefaultAssetSources();
                await this.cesdk.addDemoAssetSources({ sceneMode: 'Design' }); // Enable for David

                // Add template fonts - moved to loadScene()
                // this.addTemplateFonts();

                await this.cesdk.ui.setView('advanced');
                //await this.disableDefaultEditorFeatures(); - Leave all for David
                this.addVariablesPanel();

                await this.cesdk.createDesignScene()
                .then(response => {
                    vm.editor_loaded = true;
                    if (vm.scene.data) {
                        vm.loadScene();
                    }
                })
                .catch(function (error) {
                    vm.errors = error;
                });
            },
            async disableDefaultEditorFeatures() {
                const featuresToDisable = [
                    'ly.img.preview',
                    //'ly.img.dock',
                    'ly.img.page.move',
                    'ly.img.page.add',
                    'ly.img.page.resize',
                    'ly.img.delete',
                    'ly.img.duplicate',
                    'ly.img.replace',
                    'ly.img.transform.flip',
                    //'ly.img.text.typeface',
                    //'ly.img.text.fontStyle',
                    'ly.img.text.alignment',
                    'ly.img.text.background'
                ];

                const scopesToDeny = [
                    //'fill/change',
                    'fill/changeType',
                    'stroke/change',
                    'shape/change',
                    'layer/flip',
                    'layer/crop',
                    'layer/opacity',
                    'layer/blendMode',
                    'layer/visibility',
                    'layer/clipping',
                    'appearance/adjustments',
                    'appearance/filter',
                    'appearance/effect',
                    'appearance/blur',
                    'appearance/shadow',
                    'appearance/animation'
                ];

                const menuOrderComponentsToRemove = [
                    'ly.img.text.color.canvasMenu',
                    'ly.img.replace.canvasMenu'
                ];

                for (const feature of featuresToDisable) {
                    await this.cesdk.feature.enable(feature, false);
                }
                for (const scope of scopesToDeny) {
                    await this.cesdk.engine.editor.setGlobalScope(scope, 'Deny');
                }
                for (const component of menuOrderComponentsToRemove) {
                    await this.cesdk.ui.removeCanvasMenuOrderComponent(component, { editMode: 'Text' });
                }
            },
            addVariablesPanel: function () {
                // Register a custom Variables Manager panel
                this.cesdk.ui.registerPanel(
                    'ly.img.variablesManager',
                    ({ builder, engine: panelEngine, state }) => {
                        const { Section, TextInput, Button } = builder;
                        const newVariableName = state('newVariableName', '');
                        const newVariableValue = state('newVariableValue', '');
                        Section('create-variable', {
                            title: 'Create New Variable',
                            children: () => {
                                TextInput('new-name', {
                                    inputLabel: 'Variable Name',
                                    ...newVariableName
                                });
                                TextInput('new-value', {
                                    inputLabel: 'Default Value',
                                    ...newVariableValue
                                });
                                Button('create-btn', {
                                    label: 'Create Variable',
                                    color: 'accent',
                                    isDisabled: !newVariableName.value.trim(),
                                    onClick: () => {
                                        const name = newVariableName.value.trim();
                                        if (name) {
                                            panelEngine.variable.setString(name, newVariableValue.value);
                                            newVariableName.setValue('');
                                            newVariableValue.setValue('');
                                        }
                                    }
                                });
                            }
                        });
                        const variables = panelEngine.variable.findAll();
                        Section('existing-variables', {
                            title: `Manage Variables (${variables.length})`,
                            children: () => {
                                if (variables.length === 0) {
                                    builder.Text('no-vars', { content: 'No variables defined yet.' });
                                    return;
                                }
                                variables.forEach((varName) => {
                                    TextInput(`var-${varName}`, {
                                        inputLabel: varName,
                                        value: panelEngine.variable.getString(varName),
                                        setValue: (value) => {
                                            panelEngine.variable.setString(varName, value);
                                        },
                                        suffix: {
                                            icon: '@imgly/TrashBin',
                                            tooltip: 'Delete variable',
                                            onClick: () => {
                                                panelEngine.variable.remove(varName);
                                            }
                                        }
                                    });
                                });
                            }
                        });
                    }
                );
                // Set panel title
                this.cesdk.i18n.setTranslations({
                    en: { 'panel.ly.img.variablesManager': 'Variables Manager' }
                });
                // Add dock button
                this.cesdk.ui.registerComponent('variablesManager.dock', ({ builder: b }) => {
                    const isPanelOpen = this.cesdk.ui.isPanelOpen('ly.img.variablesManager');
                    b.Button('variables-dock-btn', {
                        label: 'Variables',
                        icon: '@imgly/Text',
                        onClick: () => {
                            isPanelOpen
                                ? this.cesdk.ui.closePanel('ly.img.variablesManager')
                                : this.cesdk.ui.openPanel('ly.img.variablesManager');
                        },
                        isActive: isPanelOpen
                    });
                });
                // Add to dock
                this.cesdk.ui.setDockOrder([
                    // Show all for David
                    ...this.cesdk.ui.getDockOrder(),
                    'ly.img.spacer',
                    'variablesManager.dock'
                ]);
            },
            reset: function (
                sceneData, 
                scene = null,
                addTemplate = false,
                replaceTemplate = false,
                assetDetailsComponent = null
            ) {
                this.loading = true;

                if (!this.canEditScene(scene)) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);
                    this.scene.data = null;
                    this.loading = false;

                    return false;
                }

                this.errors = false;
                this.scene_changed = true;
                this.editing_scene_title = false;
                this.new_scene_title = null;
                this.updating_scene_title = false;
                this.create_scene_action = null;
                this.creating_scene = false;

                if (scene !== null) {
                    scene.data = sceneData;
                    this.scene = scene;
                } else {
                    this.scene = {
                        title: '',
                        data: sceneData,
                        ready_for_tagging: false,
                        finished: false
                    };
                }
                this.add_template = addTemplate;
                this.replace_template = replaceTemplate;
                this.asset_details_component = assetDetailsComponent;
                
                if (this.editor_loaded) {
                    this.loadScene();
                }
            },
            canEditScene: function (scene) {
                if (this.$root.hasPermission('templates_import_img_ly_scenes')) {
                    return true;
                }
                if (!this.$root.hasPermission('templates_manage_img_ly_scenes')) {
                    return false;
                }
                if (scene === null) {
                    return false;
                }
                if (!scene.ready_for_tagging) {
                    return false;
                }

                return true;
            },
            loadScene: function () {
                // Add template fonts.
                this.addTemplateFonts();

                this.errors = false;
                var vm = this;
                this.cesdk.engine.scene.loadFromString(this.scene.data)
                .then(response => {
                    vm.scene.img_ly_id = response;
                    //console.log('Document loaded. Scene ID:', response);
                    setTimeout(function () {
                        //vm.showInspector();
                        vm.loading = false;
                        vm.cesdk.engine.event.subscribe([], () => {
                            vm.scene_changed = true;
                            //console.log('Scene changed' );
                        });
                        vm.setEditorFeatures();
                        if ('number_of_pages' in vm.scene) {
                            setTimeout(function () {
                                vm.scene_changed = false;
                            }, 5000);
                        }
                    }, 4000);
                })
                .catch(function (error) {
                    vm.errors = error;
                    vm.loading = false;
                });
            },
            confirmDelete: function (action) {
                if (action == 'close-editor') {
                    this.onClose(true, this.on_close_redirect_to);

                    return null;
                }
            },
            onClose: function (confirmed = false, redirectTo = null) {
                if (!confirmed && this.scene_changed) {
                    this.on_close_redirect_to = redirectTo;
                    this.$parent.confirm_delete = {
                        title: this.$root.text('Close editor', null, true),
                        text: this.$root.text('Are you sure you want to discard your current changes?', null, true),
                        component: this,
                        action: 'close-editor'
                    };
                    $('#confirm-delete-modal').modal('show');

                    return null;
                }
                console.log('Closing editor');
                this.clearEditor();
                this.scene.data = null;
                console.log('Scene data cleared');
                this.scene_changed = false;
                //this.clearEditor();
                this.$parent.hideImgLySceneEditor();
                if (this.add_template) {
                    var vm = this;
                    setTimeout(function () {
                        vm.$parent.hideTemplateAddForm();
                    }, 500);
                } else if (this.replace_template) {
                    const templateReplaceFormComponent = this.$root.findComponent(
                        this.asset_details_component,
                        'template-replace-form'
                    );
                    if (templateReplaceFormComponent) {
                        templateReplaceFormComponent.editing_template_scene = false;
                    }
                } else {
                    this.asset_details_component.editing_template_scene = false;
                }
                
                if (redirectTo) {
                    if (redirectTo.name == 'logout') {
                        const component = this.$root.findComponent(this.$parent, 'main-nav');
                        if (component) {
                            component.logout();
                        }

                        return null;
                    }
                    this.$router.push(redirectTo);
                }
            },
            clearEditor: function () {
                if (this.template_fonts.length == 0) {
                    return null;
                }
                console.log('Removing existing template fonts.');
                try {
                    // Remove existing template fonts.
                    this.cesdk.ui.updateAssetLibraryEntry('ly.img.typefaces', {
                        sourceIds: ['ly.img.typeface']
                    });
                    console.log('Removed asset library entry');
                    this.cesdk.engine.asset.removeSource('template-fonts');
                    console.log('Removed asset source: template-fonts');
                } catch (error) {
                    console.log(error);
                }
                /*const allSources = this.cesdk.engine.asset.findAllSources();
                allSources.forEach((sourceId) => {
                    if (sourceId == 'template-fonts') {
                        this.cesdk.engine.asset.removeSource(sourceId);
                        console.log('Removed asset source:', sourceId);
                    }
                });*/

                /*var vm = this;
                this.cesdk.createDesignScene()
                .then(response => {
                    console.log('Created blank document. Scene ID:', response);
                    vm.scene.img_ly_id = response;
                })
                .catch(function (error) {
                    console.log('Create blank document error:', error);
                });*/
            },
            createScene: async function (action) {
                if ((action == 'ready-for-tagging') && !this.scene.ready_for_tagging) {
                    this.scene.ready_for_tagging = 1;
                    this.scene.finished = 0;
                    this.setEditorFeatures();

                    return null;
                }
                if (!this.creating_scene) {
                    this.create_scene_action = action;
                    
                    const pages = this.cesdk.engine.scene.getPages();
                    if (pages.length == 0) {
                        this.errors = this.$root.text('The scene must contain at least one page.', null, true);
                        this.create_scene_action = null;

                        return null;
                    }

                    this.creating_scene = {
                        image_data: {},
                        previews: []
                    };

                    this.creating_scene.placeholders = await this.getPlaceholders();

                    if ((this.create_scene_action == 'finish') && (this.creating_scene.placeholders.length == 0)) {
                        this.errors = this.$root.text(
                            'The {template} must contain at least one tagged field (placeholder or variable) in order to finish.',
                            {
                                template: this.$root.text(
                                    this.$root.contents.template_title,
                                    null,
                                    false,
                                    'template_title'
                                )
                            },
                            true
                        );
                        this.create_scene_action = null;
                        this.creating_scene = false;

                        return null;
                    }
                    
                    pages.forEach((blockId, index) => {
                        this.creating_scene.previews.push(null);
                        this.exportImage(blockId, 'preview_' + index, 1100);
                    });

                    if (!this.scene.title) {
                        this.editing_scene_title = true;
                        this.errors = this.$root.text('Please give the scene a title.', null, true);
                        setTimeout(function () {
                            $('#new-scene-title').addClass('field-error');
                            $('#new-scene-title').focus();
                        }, 500);

                        return null;
                    }
                }

                this.errors = false;

                // Check image data.
                let allImagesReady = true;
                for (const [key, value] of Object.entries(this.creating_scene.image_data)) {
                    if (value === null) {
                        allImagesReady = false;
                    } else if (key.indexOf('preview_') === 0) {
                        let index = parseInt(key.replace('preview_', ''));
                        this.creating_scene.previews[index] = value;
                    } else {
                        this.creating_scene.placeholders.forEach((placeholder) => {
                            if ((placeholder.block_id == key) && !placeholder.image_data) {
                                placeholder.image_data = value;
                            }
                        });
                    }
                }

                if (!allImagesReady) {
                    var vm = this;
                    setTimeout(function () {
                        if (vm.creating_scene) {
                            vm.createScene(action);
                        }
                    }, 500);

                    return null;
                }

                const schemes = ['blob', 'bundle', 'file', 'http', 'https', 'opfs', 'data'];
                const sceneData = await this.cesdk.engine.scene.saveToString(schemes);
                const data = {
                    title: this.scene.title,
                    number_of_pages: this.cesdk.engine.scene.getPages().length,
                    data: sceneData,
                    ready_for_tagging: ((action != 'save') || this.scene.ready_for_tagging),
                    finished: (action == 'finish'),
                    placeholders: this.creating_scene.placeholders,
                    preview_images: this.creating_scene.previews
                };

                let url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/img-ly-scene';
                let method = 'post';
                if (this.scene.id) {
                    url += '/' + this.scene.id;
                    method = 'put';
                }
                var vm = this;

                axios({
                    method: method,
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    if (method == 'post') {
                        vm.scene.id = response.data.scene_id;
                    }
                    vm.scene_changed = false;
                    vm.scene.data = null;
                    vm.clearEditor();

                    if (vm.add_template) {
                        const templateAddComponent = vm.$root.findComponent(vm.$parent, 'template-add-form');
                        if (templateAddComponent) {
                            /*$('#img-ly-scene-editor').fadeOut(350);
                            vm.$root.editing_img_ly_scene = false;
                            $('body').removeClass('img-ly-scene-edit');*/
                            templateAddComponent.onImgLySceneCreated(response.data.scene_id);
                            //$('#template-add-form').fadeIn(350);

                            return null;
                        }
                    } else {
                        const templateReplaceFormComponent = vm.$root.findComponent(
                            vm.asset_details_component,
                            'template-replace-form'
                        );
                        if (templateReplaceFormComponent) {
                            templateReplaceFormComponent.onImgLySceneUpdated(vm.scene.id);
                        }
                    }

                    vm.$parent.hideImgLySceneEditor();
                    vm.creating_scene = false;
                    vm.create_scene_action = null;
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    vm.errors = error.response.data.error
                        || vm.$root.text('Something went wrong, please try again', null, true);
                    vm.creating_scene = false;
                    vm.create_scene_action = null;
                });
                /*.finally(() => {
                    vm.creating_scene = false;
                    vm.create_scene_action = null;
                });*/
            },
            getPlaceholders: async function () {
                const placeholders = await this.cesdk.engine.block.findAllPlaceholders();
                const blocks = await this.cesdk.engine.block.findAll();
                let allPlaceholders = [];
                blocks.forEach((item) => {
                    let hasVariable = this.cesdk.engine.block.referencesAnyVariables(item);
                    let isPlaceholder = (placeholders.indexOf(item) > -1)
                    if (hasVariable || isPlaceholder) {
                        let name = this.cesdk.engine.block.getName(item);
                        let type = this.cesdk.engine.block.getType(item);
                        let pageNo = this.getPageNumber(item);
                        
                        if (type == '//ly.img.ubq/text') {
                            if (isPlaceholder) {
                                allPlaceholders.push({
                                    block_id: item,
                                    name: name,
                                    type: 'T',
                                    page_number: pageNo
                                });
                            }

                            if (hasVariable) {
                                // Add variables.
                                let lineCount = this.cesdk.engine.block.getTextVisibleLineCount(item);
                                let content = [];
                                for (let line = 0; line < lineCount; line++) {
                                    content.push(this.cesdk.engine.block.getTextVisibleLineContent(item, line));
                                }
                                content = content.join(' ');

                                const parts = content.split('{{');
                                parts.forEach((part) => {
                                    let index = part.indexOf('}}');
                                    if (index > 0) {
                                        let variable = part.substring(0, index);
                                        allPlaceholders.push({
                                            block_id: variable.toLowerCase(),
                                            name: this.$root.ucfirst(variable.replace(/_/g, ' ').toLowerCase()),
                                            type: 'V',
                                            page_number: pageNo
                                        });
                                    }
                                });
                            }
                        }

                        if ((type == '//ly.img.ubq/graphic') && isPlaceholder) {
                            this.exportImage(item, item);
                            allPlaceholders.push({
                                block_id: item,
                                name: name,
                                type: 'I',
                                page_number: pageNo,
                                image_data: null
                            });
                        }
                    }
                });

                return allPlaceholders;
            },
            exportImage: async function (blockId, blockName, size = null) {
                if (!this.creating_scene) {
                    return null;
                }
                let options = {
                    mimeType: 'image/png',
                    pngCompressionLevel: 5
                };
                if (size) {
                    options.targetWidth = size;
                    options.targetHeight = size;
                }
                this.creating_scene.image_data[blockName] = null;
                const blob = await this.cesdk.engine.block.export(
                    blockId,
                    options
                );

                const blobToBase64 = async blob => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result)
                        reader.onerror = err => reject(err)
                        reader.readAsDataURL(blob)
                    })
                }

                const imageData = await blobToBase64(blob);
                this.creating_scene.image_data[blockName] = imageData;
            },
            getPageNumber: function (blockId) {
                const pages = this.cesdk.engine.scene.getPages();
                let notFound = false;
                let pageNo = 0;
                while (!notFound && (pageNo == 0)) {
                    let parent = this.cesdk.engine.block.getParent(blockId);
                    if (!parent) {
                        notFound = true;
                    } else {
                        let index = pages.indexOf(parent);
                        if (index > -1) {
                            pageNo = index + 1;
                        } else {
                            blockId = parent;
                        }
                    }
                }

                return pageNo;
            },
            /*showInspector: function () {
                if (this.cesdk.ui.isPanelOpen('//ly.img.panel/inspector')) {
                    return null;
                }
                this.cesdk.ui.openPanel('//ly.img.panel/inspector');

                var vm = this;
                setTimeout(function () {
                    vm.showInspector();
                }, 1000);
            },*/
            isReadyForTaggingDisabled: function () {
                if (this.editing_scene_title) {
                    return true;
                }
                if (this.creating_scene) {
                    return true;
                }
                if (this.scene_changed) {
                    return false;
                }
                if (this.scene.ready_for_tagging && !this.scene.finished) {
                    return true;
                } 

                return false;
            },
            isFinishDisabled: function () {
                if (this.editing_scene_title) {
                    return true;
                }
                if (this.creating_scene) {
                    return true;
                }
                if (this.scene_changed) {
                    return false;
                }
                if (this.scene.finished) {
                    return true;
                } 

                return false;
            },
            isSaveDisabled: function () {
                if (this.editing_scene_title) {
                    return true;
                }
                if (this.creating_scene) {
                    return true;
                }
                if (this.scene_changed) {
                    return false;
                }
                if (!this.scene.id) {
                    return false;
                }
                if (!this.scene.ready_for_tagging && !this.scene.finished) {
                    return true;
                } 

                return false;
            },
            showReadyForTagging: function () {
                if (!this.$root.hasPermission('templates_import_img_ly_scenes')) {
                    return false;
                }
                /*if (!this.add_template) {
                    return true;
                }*/
                if (this.scene.ready_for_tagging || this.scene.finished) {
                    return false;
                }

                return true;
            },
            showFinish: function () {
                /*if (!this.add_template) {
                    return true;
                }*/
                if (!this.scene.ready_for_tagging) {
                    return false;
                }

                return true;
            },
            getStatusKey: function () {
                let key = 'scene';
                if (this.scene.ready_for_tagging) {
                    key += '_ready_for_tagging';
                }
                if (this.scene.finished) {
                    key += '_finished';
                }

                return key;
            },
            setEditorFeatures: function () {
                if (!this.cesdk || !this.scene) {
                    return null;
                }
                const tagging = this.scene.ready_for_tagging ? true : false;

                const featuresToEnable = [
                    /* Already enabled for David
                    'ly.img.dock',
                    'ly.img.placeholder',
                    //'ly.img.text.edit',
                    */
                ];

                const featuresToDisable = [
                    'ly.img.text.fontSize',
                    'ly.img.text.advanced',
                    'ly.img.inspectorBar',
                    'ly.img.group',
                    'ly.img.transform.position',

                    // Disable the ones left enabled for David
                    'ly.img.preview',
                    'ly.img.page.move',
                    'ly.img.page.add',
                    'ly.img.page.resize',
                    'ly.img.delete',
                    'ly.img.duplicate',
                    'ly.img.replace',
                    'ly.img.transform.flip',
                    'ly.img.text.alignment',
                    'ly.img.text.background'
                ];

                const scopesToAllow = [
                    //
                ];

                const scopesToDeny = [
                    'layer/move',
                    'layer/rotate',
                    'layer/resize',

                    // Deny the ones left allowed for David
                    'fill/change',
                    'fill/changeType',
                    'stroke/change',
                    'shape/change',
                    'layer/flip',
                    'layer/crop',
                    'layer/opacity',
                    'layer/blendMode',
                    'layer/visibility',
                    'layer/clipping',
                    'appearance/adjustments',
                    'appearance/filter',
                    'appearance/effect',
                    'appearance/blur',
                    'appearance/shadow',
                    'appearance/animation'
                ];

                for (const feature of featuresToEnable) {
                    this.cesdk.feature.enable(feature, tagging);
                }
                for (const feature of featuresToDisable) {
                    this.cesdk.feature.enable(feature, !tagging);
                }
                for (const scope of scopesToAllow) {
                    this.cesdk.engine.editor.setGlobalScope(scope, tagging ? 'Allow' : 'Deny');
                }
                for (const scope of scopesToDeny) {
                    this.cesdk.engine.editor.setGlobalScope(scope, tagging ? 'Deny' : 'Allow');
                }

                if (tagging) {
                    this.cesdk.ui.setDockOrder([
                        'variablesManager.dock'
                    ]);

                    return null;
                }

                /*
                if (tagging) {
                    console.log('Enabling tagging features');

                    this.cesdk.ui.insertCanvasMenuOrderComponent(
                        'ly.img.text.italic.canvasMenu',
                        'insert-variable',
                        'after',
                        { editMode: 'Text' }
                    );
                    this.cesdk.ui.removeCanvasMenuOrderComponent('ly.img.text.bold.canvasMenu', { editMode: 'Text' });
                    this.cesdk.ui.removeCanvasMenuOrderComponent('ly.img.text.italic.canvasMenu', { editMode: 'Text' });

                    return null;
                }

                console.log('Disabling tagging features');
                this.cesdk.ui.insertCanvasMenuOrderComponent(
                    'insert-variable',
                    'ly.img.text.italic.canvasMenu',
                    'after',
                    { editMode: 'Text' }
                );
                this.cesdk.ui.insertCanvasMenuOrderComponent(
                    'insert-variable',
                    'ly.img.text.bold.canvasMenu',
                    'after',
                    { editMode: 'Text' }
                );
                this.cesdk.ui.removeCanvasMenuOrderComponent('insert-variable', { editMode: 'Text' });
                */
            },
            showError: function (title, text) {
                console.log('Showing error:', title, text);

                this.$parent.message = {
                    type: 'error',
                    title: this.$root.text(title, null, true),
                    text: this.$root.text(text, null, true)
                };
                $('#message-modal').modal('show');
            },
            addTemplateFonts: function () {
                /**
                 * Send get template fonts request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/template-fonts';
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    console.log('Adding template fonts:', response.data.fonts);
                    vm.template_fonts = response.data.fonts;

                    // Add fonts.
                    /*if (vm.template_fonts.length == 0) {
                        return null;
                    }*/

                    const sourceId = 'template-fonts';
                    let fontsAdded = [];
                    vm.cesdk.engine.asset.addLocalSource(sourceId);
                    console.log('Added local source:', sourceId);

                    vm.template_fonts.forEach((font) => {
                        if (font.files.length > 0) {
                            let fonts = [];
                            font.files.forEach((file) => {
                                let weight = file.weight;
                                if (weight == 'regular') {
                                    weight = 'normal';
                                }
                                if (weight == 'black') {
                                    weight = 'heavy';
                                }
                                fonts.push({
                                    uri: `${window.location.protocol}//${window.location.host}/fonts/client/`
                                        + file.filename,
                                    subFamily: vm.$root.ucfirst(file.weight)
                                        + (file.style == 'normal' ? '' : (' ' + vm.$root.ucfirst(file.style))),
                                    weight: weight,
                                    style: file.style
                                });
                                fontsAdded.push(font.name + '|' + file.weight + '|' + file.style);
                            });

                            vm.cesdk.engine.asset.addAssetToSource(sourceId, {
                                id: 'font-' + font.id,
                                label: {
                                    en: font.name
                                },
                                payload: {
                                    typeface: {
                                        name: font.name,
                                        fonts: fonts
                                    }
                                }
                            });
                            console.log('Added font to source:', font.name);
                        }
                    });

                    // Add IMG.LY default fonts.
                    vm.$root.img_ly_default_fonts.forEach((font) => {
                        let fonts = [];
                        font.files.forEach((file) => {
                            if (fontsAdded.indexOf(font.name + '|' + file.weight + '|' + file.style) < 0) {
                                let weight = file.weight;
                                if (weight == 'regular') {
                                    weight = 'normal';
                                }
                                if (weight == 'black') {
                                    weight = 'heavy';
                                }
                                fonts.push({
                                    uri: `${window.location.protocol}//${window.location.host}/img-ly-assets/`
                                        + 'ly.img.typeface/fonts/' + font.folder + '/' + file.filename,
                                    subFamily: file.subfamily,
                                    weight: weight,
                                    style: file.style
                                });
                            }
                        });
                        if (fonts.length > 0) {
                            vm.cesdk.engine.asset.addAssetToSource(sourceId, {
                                id: font.id,
                                label: {
                                    en: font.name
                                },
                                payload: {
                                    typeface: {
                                        name: font.name,
                                        fonts: fonts
                                    }
                                }
                            });
                            console.log('Added font to source:', font.name);
                        }
                    });

                    vm.cesdk.ui.updateAssetLibraryEntry('ly.img.typefaces', {
                        sourceIds: [sourceId/*, 'ly.img.typeface'*/]
                    });
                    console.log('Updated asset library entry for typefaces.');
                })
                .catch(function (error) {
                    //
                });
            }
        }
    }
</script>
<style scoped>
    #img-ly-scene-editor {
        display: none;
        max-width: 1600px;
    }

    h5.scene-title {
        display: inline-block;
    }
</style>
